import { useEffect, useState } from 'react';
import { api } from './api';

// Configurações do sistema (tela "Configurações", só superadmin grava). Uma consulta por sessão de página;
// `recarregarConfig()` depois de salvar. Se a API falhar, cai nos padrões (OpenStreetMap) — o painel nunca
// deve parar de funcionar por causa de configuração.
const PADRAO = {
  mapa: { tipo: 'openstreetmap', google_key: '' },
  aparencia: { corPrimaria: '#051c3e', corDestaque: '#ffc107', logoUrl: 'https://cdn.eimovel.com.br/img/sistema/logo-horizontal-login.png' },
};
let promessa = null;

export function obterConfig() {
  if (!promessa) {
    promessa = api
      .get('/configuracoes')
      .then((r) => ({ ...PADRAO, ...r.data }))
      .catch(() => {
        promessa = null;
        return PADRAO;
      });
  }
  return promessa;
}

export function recarregarConfig() {
  promessa = null;
  return obterConfig();
}

// Usado em Login/TelaPublica/Layout (28/09/2026) — o logo configurável. Começa com o padrão (nunca
// aparece em branco) e troca sozinho se a Configurações → Aparência tiver um logo diferente.
export function useLogoUrl() {
  const [url, setUrl] = useState(PADRAO.aparencia.logoUrl);
  useEffect(() => {
    let vivo = true;
    obterConfig().then((c) => {
      if (vivo && c.aparencia?.logoUrl) setUrl(c.aparencia.logoUrl);
    });
    return () => {
      vivo = false;
    };
  }, []);
  return url;
}
